import { render, staticRenderFns } from "./BankMatchedItemPreview.vue?vue&type=template&id=19fe0838&scoped=true&"
import script from "./BankMatchedItemPreview.vue?vue&type=script&lang=js&"
export * from "./BankMatchedItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./BankMatchedItemPreview.vue?vue&type=style&index=0&id=19fe0838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fe0838",
  null
  
)

export default component.exports